createLocationQuery